import { render } from "./IconPreset.vue?vue&type=template&id=f1663a0a"
import script from "./IconPreset.vue?vue&type=script&lang=ts"
export * from "./IconPreset.vue?vue&type=script&lang=ts"
script.render = render

export default script